// Deps
import { useState, useEffect } from 'react'
import { setError } from 'controllers/navigator'
import store from 'store'

// Services
import sysServices from 'services/sys'

const getCurrentCities = () => {
	return store.getState().site.cities;
}

const useCities = (active = true) => {
	const [cities, setCities] = useState(getCurrentCities());

	useEffect(() => {
		if(active && !cities) {
			sysServices.getCities().then((payload) => {
				setCities(payload);
			}).catch(() => {
				setError();
			})
		}
	}, [cities, active])

	return cities;
}

export default useCities;